<div class="zf-login">

  <aside class="zf-login-aside">
    <div class="zf-glow"></div>

    <div class="zf-login-brand">
      <img src="images/zenflow-mark.png" alt="Zenflow" />
      <div class="d-flex align-items-baseline gap-3">
        <span class="zf-brand-name">ZENFLOW</span>
        <span class="zf-brand-sub">AI ERP</span>
      </div>
    </div>

    <div class="zf-login-copy">
      <span class="zf-edition"><span class="zf-dot"></span>Enterprise Edition</span>
      <h1>Every item, price and movement — one ledger.</h1>
      <p class="zf-lede">Purchasing, receiving and stock movement in one place — for retail counters, pharmacies, clinics, field branches and everything in between.</p>
      <div class="zf-points">
        <div>Order to shelf in one continuous trail</div>
        <div>Batch, expiry and pricing tracked on every line</div>
        <div>Live stock across every store, branch and store-room</div>
      </div>
      <div class="zf-stats">
        <div><strong>Multi-branch</strong><span>Single ledger</span></div>
        <div><strong>Offline POS</strong><span>Billing never stops</span></div>
        <div><strong>GST ready</strong><span>e-Way bill &amp; HSN</span></div>
      </div>
    </div>

    <div class="zf-login-foot">
      <span>Zenflow Retail</span>
      <span class="right">© {{ year }} Zenflow Systems Private Limited</span>
    </div>
  </aside>

  <main class="zf-login-main">
    <form class="zf-login-card" [formGroup]="loginForm" (ngSubmit)="onSubmit()" novalidate>
      <div class="d-flex flex-column gap-2">
        <h2>Sign in</h2>
        <p class="zf-help">Sign in with the username or work email your administrator set up for you. Your location is assigned from your login profile.</p>
      </div>

      <div class="zf-fields">
        <label class="zf-field">
          <span class="zf-label">Username or email</span>
          <span class="zf-input">
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="#ABAFB9" stroke-width="1.8"
                 stroke-linecap="round" stroke-linejoin="round"><path d="M4 5.5h16v13H4z"></path><path d="M4.6 6.4 12 12.4l7.4-6"></path></svg>
            <input type="text" formControlName="identifier" placeholder="name@company.com"
                   autocomplete="username" autofocus />
          </span>
        </label>

        <label class="zf-field">
          <span class="zf-label">Password</span>
          <span class="zf-input">
            <input [type]="showSecret ? 'text' : 'password'" formControlName="secret" placeholder="••••••••"
                   autocomplete="current-password" />
            <button type="button" class="zf-toggle" (click)="showSecret = !showSecret"
                    [attr.aria-label]="showSecret ? 'Hide password' : 'Show password'"
                    [attr.aria-pressed]="showSecret">{{ showSecret ? 'HIDE' : 'SHOW' }}</button>
          </span>
        </label>
      </div>

      @if (error) {
        <div class="zf-error" role="alert">
          <i class="bi bi-exclamation-triangle-fill"></i>
          <span>{{ error }}</span>
        </div>
      }

      <button type="submit" class="zf-submit" [disabled]="submitting">
        @if (submitting) {
          <span class="spinner-border spinner-border-sm"></span> Signing in…
        } @else {
          Sign in
        }
      </button>

      <p class="zf-fine">Activity on this device is logged against your account. Report discrepancies to your administrator within 24 hours.</p>
    </form>
  </main>
</div>
